import { useTranslation } from "react-i18next";
import SEOMeta from "@/components/base/SEOMeta";
import SchemaOrg from "@/components/base/SchemaOrg";
import HeroSection from "./components/HeroSection";
import FeaturedReviews from "./components/FeaturedReviews";
import CategorySection from "./components/CategorySection";
import RankingSection from "./components/RankingSection";
import LatestArticles from "./components/LatestArticles";

export default function Home() {
  const { t } = useTranslation();

  return (
    <>
      <SEOMeta
        title={t("seo.homeTitle")}
        description={t("seo.homeDesc")}
        keywords={t("seo.homeKeywords")}
        canonicalUrl="https://haohuai.me"
        ogImage="https://readdy.ai/api/search-image?query=Abstract%20artistic%20anime%20illustration%20with%20warm%20coral%20and%20gold%20tones%2C%20minimalist%20design%2C%20clean%20composition%2C%20soft%20gradients%2C%20modern%20aesthetic&width=1200&height=630&seq=og-home&orientation=landscape"
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: "好坏动漫",
          url: "https://haohuai.me",
          description: t("seo.homeDesc"),
          potentialAction: {
            "@type": "SearchAction",
            target: "https://haohuai.me/category/all?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: t("seo.homeTitle"),
          url: "https://haohuai.me",
          description: t("seo.homeDesc"),
        }}
      />

      <main>
        <HeroSection />
        <FeaturedReviews />
        <CategorySection />
        <RankingSection />
        <LatestArticles />
      </main>
    </>
  );
}